import {
    NDS_LOADED, NDS_LOADING,
} from "../../actions/actionTypes";

const initialState = {
    ndsItems: [],
    loading: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case NDS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case NDS_LOADED:
            return {
                ...state,
                loading: false,
                ndsItems: action.payload,
            };
        default:
            return state;
    }
}